<template>
  <div class="d-flex fixed-search-result-height">
    <!--
      needs to be component 
    -->
    <v-row v-if="warn" no-gutters>
      <v-col class="align-center d-flex font-size-xs ml-10">
        <div class="position-relative">
          <AlcoholWarning v-if="product.is_alcohol" />
          <TobaccoWarning v-if="product.is_tobacco" />
        </div>
        <div>
          <v-btn color="#e21b23" icon @click.stop="warn = !warn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <!--
      needs to be component
    -->
    <div
      v-else
      class="align-center cursor-pointer d-flex full-width"
      @click.stop="toProductDetail"
    >
      <v-row justify="center" no-gutters>
        <v-col sm="11" md="11" lg="8" xl="8">
          <v-row no-gutters>
            <v-col
              cols="4"
              class="d-flex justify-center overflow-hidden position-relative"
            >
              <CornerRibbon
                class="z-index-1"
                v-if="
                  (product.pricebook_info.promotions &&
                    product.pricebook_info.promotions.length) ||
                  product.new_product
                "
                :newItem="
                  !(
                    product.pricebook_info.promotions &&
                    product.pricebook_info.promotions.length
                  )
                "
              />
              <FavoriteIcon
                :upc="product.upc"
                class="favorite-button-position"
                mobile
              />
              <div
                class="align-self-center d-flex fixed-width-image-container"
                :class="{ 'position-relative': $vuetify.breakpoint.smAndDown }"
              >
                <img
                  v-if="product.image"
                  :alt="product.name"
                  :src="product.image"
                  class="product-image-size-xs e2e-searchresult-image"
                  loading="lazy"
                />
                <NoImageAvailable
                  v-else
                  :departmentName="
                    getProductDepartmentName(
                      product.parent_categories,
                      product.categories
                    )
                  "
                  :size="'xs'"
                />
              </div>
            </v-col>
            <v-col cols="4">
              <div class="align-self-center d-flex flex-column ml-2">
                <div
                  v-line-clamp="3"
                  class="color-dim-gray e2e-searchresult-name line-height-1 word-break-normal"
                >
                  {{ removeLongWordsFromProductName(product.name) }}
                </div>
                <UnitSizeDisplay
                  :baseSize="product.base_size"
                  :size="product.size"
                  :uom="product.uom"
                  small
                />
                <UnitPriceDisplay
                  :byweight="product.byweight"
                  :type="'search'"
                  :unitPrice="product.cents"
                />
                <div
                  v-if="product.is_tobacco || product.is_alcohol"
                  class="font-size-xxs e2e-searchresult-product-warn"
                  @click.stop="warn = !warn"
                >
                  California Residents:
                  <a>Click here for Proposition 65 WARNING</a>
                </div>
              </div>
            </v-col>
            <v-col
              class="align-center align-self-center d-flex flex-column"
              cols="4"
            >
              <div>
                <TobaccoButton v-if="product.is_tobacco" small />
                <CartQuantityButton
                  v-else
                  :cartProduct="cartProduct"
                  :quantityType="'cartQty'"
                  small
                />
              </div>
              <TermsSingle
                :byweight="product.byweight"
                :promotions="product.pricebook_info.promotions"
                small
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  getProductDepartmentName,
  getProductDetailViewFromProductState,
  removeLongWordsFromProductName,
} from "@/util.js";
import { mapGetters } from "vuex";
import AlcoholWarning from "@/components/Product/AlcoholWarning.vue";
import CartQuantityButton from "@/components/Product/CartQuantityButton.vue";
import FavoriteIcon from "@/components/Product/FavoriteIcon.vue";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import CornerRibbon from "@/components/Product/Promotions/CornerRibbon.vue";
import TermsSingle from "@/components/Product/Promotions/Terms/Single.vue";
import TobaccoButton from "@/components/Product/TobaccoButton.vue";
import TobaccoWarning from "@/components/Product/TobaccoWarning.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";
import UnitSizeDisplay from "@/components/Product/UnitSizeDisplay.vue";

export default {
  name: "Product",
  components: {
    AlcoholWarning,
    CartQuantityButton,
    FavoriteIcon,
    NoImageAvailable,
    CornerRibbon,
    TermsSingle,
    TobaccoButton,
    TobaccoWarning,
    UnitPriceDisplay,
    UnitSizeDisplay,
  },
  computed: {
    ...mapGetters({
      getProductItemsAndQuantityInCart: "cart/getProductItemsAndQuantityInCart",
    }),
    cartProduct: function () {
      const itemsAndQuantityFromCart = this.getProductItemsAndQuantityInCart(
        this.product
      );
      return { ...this.product, ...itemsAndQuantityFromCart };
    },
  },
  data() {
    return {
      warn: false,
    };
  },
  methods: {
    getProductDepartmentName,
    getProductDetailViewFromProductState,
    removeLongWordsFromProductName,
    toProductDetail() {
      this.$store.dispatch(
        "product/setCurrentProductDetails",
        this.cartProduct
      );
      const view = getProductDetailViewFromProductState(this.cartProduct);
      this.$vuetify.breakpoint.xsOnly
        ? this.$router.push({
            name: "product",
            params: { upc: this.cartProduct.upc_encoded, view },
          })
        : this.$store.dispatch("product/openDialog", view);
    },
  },
  props: { product: Object },
};
</script>

<style scoped>
.favorite-button-position {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.fixed-search-result-height {
  height: 140px;
}

.fixed-width-image-container {
  width: 80px;
}

.word-break-normal {
  word-break: normal;
}
</style>
